export const RETENTION_SCREEN_STATES = {
  REQUIRES_RETENTION_PLAN: 'requires_retention_plan',
  REQUIRES_HISTORICAL_ANALYSIS: 'requires_historical_analysis',
  ANALYSIS_PENDING: 'analysis_pending',
  READY: 'ready'
};

const RETENTION_SCREEN_COPY = {
  [RETENTION_SCREEN_STATES.REQUIRES_RETENTION_PLAN]: {
    title: 'Effort Survival Cohort',
    body: 'Your current plan does not include Effort Survival Cohort. Update your plan configuration to unlock this section.',
    ctaLabel: 'Go to Plan Configuration',
    ctaPath: '/settings/plan-configuration'
  },
  [RETENTION_SCREEN_STATES.REQUIRES_HISTORICAL_ANALYSIS]: {
    title: 'Effort Survival Cohort',
    body: 'We need at least 1 full month of analysis history to generate Effort Survival Cohort. Extend your analysis window from Historical Analysis to continue.',
    ctaLabel: 'Go to Historical Analysis',
    ctaPath: '/settings/historical-analysis'
  },
  [RETENTION_SCREEN_STATES.ANALYSIS_PENDING]: {
    title: 'Effort Survival Cohort',
    body: 'Your workspace is eligible for Effort Survival Cohort, but this analysis is not ready yet. Open a support request and our team will check it for you.',
    ctaLabel: 'Open Support Request',
    ctaPath: '/settings/support'
  }
};

export const getRetentionScreenOverlayContent = (
  screenState,
  screenStateMeta = null
) => {
  const content = RETENTION_SCREEN_COPY[screenState];

  if (!content) {
    return null;
  }

  return {
    title: content.title,
    body: content.body,
    ctaLabel: screenStateMeta?.cta_label || content.ctaLabel,
    ctaPath: screenStateMeta?.cta_path || content.ctaPath
  };
};
